import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(VBtn,{class:_vm.btnClass,attrs:{"disabled":_vm.disable || _vm.currentPage <= 1},on:{"click":_vm.previousPage}},[_vm._v(" "+_vm._s(_vm.$t("Previous"))+" ")]),_c(VBtn,{class:_vm.btnClass,attrs:{"disabled":_vm.disable || _vm.currentPage >= _vm.lastPage},on:{"click":_vm.nextPage}},[_vm._v(" "+_vm._s(_vm.$t("Next"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }